import { ButtonProps } from '../Button';
import AffiliateButton from './AffiliateButton';
import NFHSImageV2 from 'images/icons/NFHSN_Horizontal_Black.png';

export default function NFHSButtonV2(props: ButtonProps) {
  return <AffiliateButton {...props} image={NFHSImageV2} imageStyle={{ width: '117px' }} />;
}
